import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'checkbox-container',
    templateUrl: './checkbox-container.component.html',
    styleUrls: ['./checkbox-container.component.scss'],
    standalone: false
})
export class CheckboxContainerComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
